import BaseProcessor from './BaseProcessor';
import store from '@/store';
import { logEvent } from '@/helpers/cieloLogger';

export default class PixOpenFinanceProcessor extends BaseProcessor {
    constructor(multiLanguage) {
        super(multiLanguage);
    }

    /**
     * Processa a transação pix open finance
     */
    async ProcessTransaction() {
        super.BuildContract({
            Card: {
                ...store.getters['billingAddress/getSubmitModel']
            },
            ...store.getters['pixOpenFinancePayment/getSubmitModel'],
        });

        let response = await super.SendTransactionRequest();

        if (super.ResponseIsSuccess(response) == false) return;

        const bankRedirectUrl = response.Data.OpenFinanceRedirectUrl;

        if (bankRedirectUrl) {

            logEvent({
                category: 'itp',
                action: 'concluir_compra_itp​',
                label: `Usuário preenche os dados pessoais, clica em continuar e é redirecionado para URL do banco.`
            });

            store.dispatch('preorder/setTransactionAsFinalized');

            store.commit('pixOpenFinancePayment/setSubmitResponse', response.Data);

            store.commit('pixOpenFinancePayment/openBankRedirectModal');

            window.location.href = bankRedirectUrl;
        }

    }
}
